import React, { useState } from "react";
import "./services.css";
import engementImg     from '../../Assets/Services/Engement.webp';
import preWeddingImg   from '../../Assets/Services/PreWedding.webp';
import weddingImg      from '../../Assets/Services/Wedding.webp';
import babyShowerImg   from '../../Assets/Services/BabyShower.webp';
import babyBornImg     from '../../Assets/Services/BabyBorn.webp';
import fashionImg      from '../../Assets/Services/Fashion.webp';
import architecturalImg from '../../Assets/Services/Architectural.webp';
import droneImg        from '../../Assets/Services/Drone.webp';
import birthdayImg     from '../../Assets/Services/Birthday.webp';
import productImg      from '../../Assets/Services/Products.webp';

/* ── SERVICE DATA ── */
const SERVICES = [
  {
    title: "Engagement",
    subtitle: "Ring ceremonies & proposals",
    image: engementImg,
    icon: "💍",
    drivelink: "https://drive.google.com/drive/folders/1gJa1vG_yCngbU_0doen9ox5Amn_txtds?usp=sharing",
    tag: "Popular",
  },
  {
    title: "Pre-Wedding",
    subtitle: "Romantic pre-wedding shoots",
    image: preWeddingImg,
    icon: "🌸",
    drivelink: "https://drive.google.com/drive/folders/1LOn7c46Srg3gfzk_22x9U1ZeR65VePib?usp=sharing",
    tag: "Trending",
  },
  {
    title: "Wedding",
    subtitle: "Full-day wedding coverage",
    image: weddingImg,
    icon: "👰",
    drivelink: "https://drive.google.com/drive/folders/1ZNWt3IAeE9B2UuHLEyKWXli6I_BRBMAx?usp=sharing",
    tag: "Best Seller",
  },
  {
    title: "Baby Shower",
    subtitle: "Maternity & shower celebrations",
    image: babyShowerImg,
    icon: "🍼",
    drivelink: "https://drive.google.com/drive/folders/10UVninMMOnH1a46pmEKMcsM-xj_LgaH_?usp=sharing",
  },
  {
    title: "Newborn",
    subtitle: "First days captured forever",
    image: babyBornImg,
    icon: "👶",
    drivelink: "https://drive.google.com/drive/folders/1h7dNt8hicOYTDToR3-GaEVge_rqlfJkd?usp=sharing",
  },
  {
    title: "Birthday",
    subtitle: "Milestone birthday parties",
    image: birthdayImg,
    icon: "🎂",
    drivelink: "https://drive.google.com/drive/folders/1wqBCUrig_quN7MiH59mVl04qrNAFtRL5?usp=sharing",
  },
  {
    title: "Fashion & Modelling",
    subtitle: "Editorial & portfolio shoots",
    image: fashionImg,
    icon: "👗",
    drivelink: "https://drive.google.com/drive/folders/1Mrvp2vK9Pz6pX1m1701NggEaknlH4UnH?usp=sharing",
  },
  {
    title: "Architecture",
    subtitle: "Real estate & interior spaces",
    image: architecturalImg,
    icon: "🏛️",
    drivelink: "https://drive.google.com/drive/folders/1H2oxXpVXQmBRAvdNzMUxKjDw4JzHe4xt?usp=sharing",
  },
  {
    title: "Product",
    subtitle: "Commercial product photography",
    image: productImg,
    icon: "📦",
    drivelink: "https://drive.google.com/drive/folders/1QqYXqTQhn9Y11b8kY-IC0t7ofIQrDGFV?usp=sharing",
  },
  {
    title: "Drone",
    subtitle: "Stunning aerial cinematography",
    image: droneImg,
    icon: "🚁",
    drivelink: "https://drive.google.com/drive/folders/1shSzgqdTeTlxAX9sSBxbKiKH5HYR4hK3?usp=sharing",
    tag: "New",
  },
];

const INITIAL_COUNT = 6;

const Services = () => {
  const [showAll, setShowAll] = useState(false);

  const visible = showAll ? SERVICES : SERVICES.slice(0, INITIAL_COUNT);

  return (
    <section className="services-section" id="projects">

      {/* ── HEADER ── */}
      <div className="services-header">
        <span className="services-eyebrow">What We Offer</span>
        <h2 className="services-title">Our Services</h2>
        <div className="services-ornament">
          <span />
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#C9A84C">
            <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4z"/>
          </svg>
          <span />
        </div>
        <p className="services-subtitle">
          From intimate ceremonies to grand productions — we capture every emotion, every detail.
        </p>
      </div>

      {/* ── GRID ── */}
      <div className="services-grid">
        {visible.map((service, i) => (
          <a
            key={service.title}
            href={service.drivelink}
            target="_blank"
            rel="noopener noreferrer"
            className="service-card"
            style={{ animationDelay: `${(i % INITIAL_COUNT) * 0.07}s` }}
            aria-label={`View ${service.title} portfolio on Google Drive`}
          >
            {/* Tag badge */}
            {service.tag && (
              <span className="service-tag">{service.tag}</span>
            )}

            {/* Background image */}
            <div
              className="service-img"
              style={{ backgroundImage: `url(${service.image})` }}
            />

            {/* Gradient overlay always visible */}
            <div className="service-gradient" />

            {/* Bottom content — always visible */}
            <div className="service-bottom">
              <span className="service-icon">{service.icon}</span>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-subtitle">{service.subtitle}</p>
            </div>

            {/* Hover overlay — slides up */}
            <div className="service-hover-overlay">
              <div className="service-hover-inner">
                <span className="service-hover-icon">{service.icon}</span>
                <h3 className="service-hover-title">{service.title}</h3>
                <p className="service-hover-sub">{service.subtitle}</p>
                <span className="service-hover-cta">
                  View Portfolio
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="5" y1="12" x2="19" y2="12"/>
                    <polyline points="12 5 19 12 12 19"/>
                  </svg>
                </span>
              </div>
            </div>

          </a>
        ))}
      </div>

      {/* ── TOGGLE BUTTON ── */}
      <div className="services-footer">
        {!showAll && SERVICES.length > INITIAL_COUNT && (
          <button className="services-toggle-btn" onClick={() => setShowAll(true)}>
            <span>View All Services</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="6 9 12 15 18 9"/>
            </svg>
          </button>
        )}
        {showAll && (
          <button className="services-toggle-btn services-toggle-btn--collapse" onClick={() => setShowAll(false)}>
            <span>Show Less</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="18 15 12 9 6 15"/>
            </svg>
          </button>
        )}

        {/* CTA below */}
        <p className="services-cta-text">Don't see your event type?</p>
        <a href="#Contact" className="services-contact-link">
          Contact us — we photograph everything ✦
        </a>
      </div>

    </section>
  );
};

export default Services;